export class InvestigationClosingReasonEntity {
  public id!: string;
  public name!: string;
  public sortOrder!: number;
}
